import React from "react";
import { Grid2 } from "@mui/material";
import BillingHeadersContentStyles from "./BillingHeadersContent.module.scss";
import { formatDate } from "../../../../../../Utils/utils";
import { useSelector } from "react-redux";

const BillingHeadersContent = (props) => {
  const {
    currentPlan,
    invoiceBill,
    navigate,
    orgId,
    isPlanExpiredOrExpiring,
    basePlan,
    dedicatedHosting,
  } = props;

  const startDate = formatDate(currentPlan?.creationDate);
  const nextPaymentDate = formatDate(currentPlan?.expirationDate);
  const planName = currentPlan?.licenseType;
  const selectedOrg = useSelector(
    (state) => state.organizationsInfo?.selectedOrg,
  );

  const isSingleSite = currentPlan?.isSingleSite;
  const userDetails = useSelector((state) => state.users?.userDetails);

  const country = selectedOrg?.country || userDetails?.country;

  const isplan =
    (basePlan && dedicatedHosting === true) ||
    (basePlan && dedicatedHosting === false);

  const headersData = [
    { header: "Start Date", subheader: startDate },
    { header: "Next Payment", subheader: nextPaymentDate },
    {
      header: "Plan",
      subheader: `${isSingleSite ? "SS - " : "MS - "} ${planName}`,
    },
    {
      header: "Upcoming Invoice",
      subheader: `${country === "USA" ? "$ " : "₹ "} ${invoiceBill}`,
    },
  ];

  return (
    <Grid2 className={BillingHeadersContentStyles.BillingHeadersContent}>
      {headersData.map((data, index) => (
        <Grid2
          item
          key={index}
          className={BillingHeadersContentStyles.headerContainer}
        >
          <Grid2 className={BillingHeadersContentStyles.container}>
            <Grid2>
              <Grid2 className={BillingHeadersContentStyles.header}>
                {data.header}
              </Grid2>
              <Grid2
                className={`${BillingHeadersContentStyles.subheader} ${
                  data.header === "Next Payment" && isPlanExpiredOrExpiring
                    ? BillingHeadersContentStyles.expired
                    : ""
                }`}
                onClick={
                  data.header === "Upcoming Invoice" && isPlanExpiredOrExpiring
                    ? () => {
                        navigate(`/account/${orgId}/modify-plan?renew=true`);
                      }
                    : undefined
                }
              >
                {data.subheader}{" "}
                {isPlanExpiredOrExpiring && (
                  <>
                    {data.header === "Next Payment" && (
                      <span className={BillingHeadersContentStyles.expiredPlan}>
                        Expired
                      </span>
                    )}
                    {data.header === "Upcoming Invoice" && (
                      <span className={BillingHeadersContentStyles.renewPlan}>
                        Renew Now
                      </span>
                    )}
                  </>
                )}
                {isplan && (
                  <>
                    {data.header === "Plan" && (
                      <span className={BillingHeadersContentStyles.isPlan}>
                        {dedicatedHosting === true ? "dedicated" : "Kubernetes"}
                      </span>
                    )}
                  </>
                )}
              </Grid2>
            </Grid2>
            {index !== headersData.length - 1 && (
              <Grid2 className={BillingHeadersContentStyles.headerLine} />
            )}
          </Grid2>
        </Grid2>
      ))}
    </Grid2>
  );
};

export default BillingHeadersContent;
